import React from "react";
import { getLastRequestId, reportClientError } from "../lib/api";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      requestId: null,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true, requestId: getLastRequestId() };
  }

  componentDidCatch(error, errorInfo) {
    reportClientError({
      error_message: String(error?.message || "Unhandled frontend error"),
      stack: String(error?.stack || ""),
      component_stack: String(errorInfo?.componentStack || ""),
      request_id: getLastRequestId(),
      url: window.location.href,
      user_agent: navigator.userAgent,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
        <div className="max-w-xl w-full rounded-xl border bg-white shadow p-6 space-y-4">
          <h1 className="text-2xl font-bold text-slate-900">Something went wrong</h1>
          <p className="text-slate-600">
            Unexpected error occurred. Please reload. If this repeats, share Request ID with support.
          </p>
          <div className="text-sm text-slate-700">
            <span className="font-semibold">Request ID:</span> {this.state.requestId || "not available"}
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center rounded-md bg-slate-900 text-white px-4 py-2 text-sm font-medium hover:bg-slate-700"
          >
            Reload App
          </button>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
